import type { ExploreContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo } from './exploreContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo';
import type { ExploreContentItemContentOneOfReferencedTweetTweetAuthorSocial } from './exploreContentItemContentOneOfReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type ExploreContentItemContentOneOfReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: ExploreContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: ExploreContentItemContentOneOfReferencedTweetTweetAuthorSocial;
};
